import api from '@services/api';
import { DetailsRequest, UndoUnionDetailsRequest, UnitDetailsRequest } from '../models/details';
import { DetailsBooksResponse, DetailsBookTransfer, UpdateBookRequest } from '../models/detailsBooks';

/**
 * <p>
 * API endpoints that cover all details books related CRUD calls
 */
export const detailsBooksApi = api.injectEndpoints({
  endpoints: (builder) => ({
    searchDetailsBook: builder.query<DetailsBooksResponse, DetailsRequest>({
      query: (params: DetailsRequest) => ({
        url: encodeURI(
          `/report/details-book/search?searchTerm=${params.searchTerm}&projectCode=${params.project}&period=${params.period}&subgroup=${params.subGroup}&`,
        ),
      }),
      providesTags: ['searchDetailsBook', 'SearchEquipment', 'SearchDetails'],
    }),
    UnitBook: builder.mutation<void, UnitDetailsRequest>({
      query: (project) => ({
        url: encodeURI(`/report/details-book/group`),
        method: 'POST',
        body: project,
      }),
      invalidatesTags: ['searchDetailsBook'],
    }),
    undoUnionBook: builder.mutation<void, UndoUnionDetailsRequest>({
      query: (project) => ({
        url: encodeURI(`/report/details-book/ungroup`),
        method: 'POST',
        body: project,
      }),
      invalidatesTags: ['searchDetailsBook'],
    }),
    updateDetailsBook: builder.mutation<void, UpdateBookRequest>({
      query: (project) => ({
        url: encodeURI(`/report/details-book/update`),
        method: 'PUT',
        body: project,
      }),
      invalidatesTags: ['searchDetailsBook'],
    }),
    BookTransfer: builder.mutation<void, DetailsBookTransfer>({
      query: (project) => ({
        url: encodeURI(`/report/details-book/transfer`),
        method: 'POST',
        body: project,
      }),
      invalidatesTags: ['searchDetailsBook', 'SearchDetails'],
    }),
  }),
});

export const {
  useSearchDetailsBookQuery,
  useUnitBookMutation,
  useUndoUnionBookMutation,
  useUpdateDetailsBookMutation,
  useBookTransferMutation,
} = detailsBooksApi;
